export const pfPt = {
  port_name: "portname",
  exter_port: "port_start",
  internal_port: "internal_port_start",
  lan_ip: "server_ip",
  attach_device: "table_attached_devices",
};

export default pfPt;
